export default {
  steps: {
    discount: 'Remise',
    mobile_app: 'Application mobile',
    business_info: 'Informations entreprise',
    create_preview: 'Créer un aperçu du contrat',
    preview: 'Aperçu du contrat',
    sign: 'Signer le contrat',
  },
  buttons: {
    back: 'Retour',
    continue: 'Continuer',
  },
  agreement:
    "Le passage à l'annuel applique la remise de {{discount}}% à votre plan {{plan}}. La facturation continue mensuellement à {{amount}} par mois sur un engagement de {{months}} mois.",
  toasts: {
    failed_to_save_changes: "Impossible d'enregistrer les modifications",
    failed_to_switch: "Échec du passage à l'annuel",
    switched_to_annual: 'Contrat basculé en annuel 👌',
  },
};
